import { useCallback, useRef } from "react";

const CONTEXT_MENU_SELECTOR = ".eh-context-menu";
const TOUR_SELECTOR = ".eh-tour";

/**
 * Wird beim Laden gesetzt, also vor den Listenern von Headless UI.
 * So ist das Flag schon true, wenn der Dialog im selben pointerdown schließt.
 */
let suppressDialogClose = false;

function armFromPointer(event: PointerEvent) {
  const target = event.target instanceof Element ? event.target : null;
  if (
    event.button === 2 ||
    Boolean(target?.closest(`${CONTEXT_MENU_SELECTOR}, ${TOUR_SELECTOR}`))
  ) {
    suppressDialogClose = true;
  }
}

function releaseAfterPointerUp() {
  window.setTimeout(() => {
    suppressDialogClose = false;
  }, 0);
}

if (typeof window !== "undefined") {
  window.addEventListener("pointerdown", armFromPointer, true);
  window.addEventListener("pointerup", releaseAfterPointerUp, true);
  window.addEventListener("pointercancel", releaseAfterPointerUp, true);
}

/** True, solange ein Klick auf Kontextmenü oder Führung den Dialog nicht schließen darf. */
export function isDialogDismissSuppressed(): boolean {
  return suppressDialogClose;
}

/**
 * Headless-UI-Dialoge rufen `onClose` bei jedem Zeiger-Ereignis außerhalb des
 * Panels auf. Rechtsklick und das nach `document.body` portierte Kontextmenü
 * (z. B. „Bild kopieren“) liegen außerhalb und würden sonst die Vorschau
 * beziehungsweise das darüberliegende Fenster schließen.
 */
export function useDialogDismissGuard(open: boolean, onClose: () => void): () => void {
  const onCloseRef = useRef(onClose);
  onCloseRef.current = onClose;
  const openRef = useRef(open);
  openRef.current = open;

  return useCallback(() => {
    if (!openRef.current) return;
    if (suppressDialogClose) return;
    if (document.querySelector(CONTEXT_MENU_SELECTOR)) return;
    onCloseRef.current();
  }, []);
}
